import React from 'react';
import UtilityService from '../../../services/UtilityService';

export const FormErrorLabelTestId = 'formerrorlabel-input';

export type FormErrorLabelProps = {
  errors?: string[];
  lessPadding?: boolean;
};

const FormErrorLabel: React.FC<FormErrorLabelProps> = ({
  errors = [],
  lessPadding,
}: FormErrorLabelProps) => {
  const errorMessages = UtilityService.convertHtmlErrorsToStringArray(errors);
  return errors && errors.length ? (
    <div
      className={`${!lessPadding ? 'p-2' : 'pt-2'}`}
      data-testid={FormErrorLabelTestId}
    >
      <ul
        className={`text-xs text-red-700 bg-red-50 rounded-md ${
          !lessPadding ? 'p-4' : 'p-2'
        }`}
      >
        {errorMessages.map(errorMessage => (
          <li key={`error-${errorMessage}`}>
            {UtilityService.sanitizeString(errorMessage)}
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default FormErrorLabel;
